// Ticks a routine line on the sitter's note once its product reaches the basket.
(() => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, ({ source, productVariantId }) => {
    if (source !== 'product-form' || !productVariantId) return;
    const line = document.querySelector(`.note-line[data-variant-id="${productVariantId}"], .kitto-slip[data-variant-id="${productVariantId}"]`);
    if (!line) return;
    line.classList.remove('is-ticking');
    void line.offsetWidth;
    line.classList.add('is-ticked', 'is-ticking');
    setTimeout(() => line.classList.remove('is-ticking'), 700);
    const label = line.querySelector('.note-add__label');
    if (label) label.textContent = 'Add another';
  });
})();
